// initial state
const state = () => ({
  messages: [],
});

// getters
const getters = {
  getMessages: state => {
    return state.messages;
  },
};

// actions
const actions = {
  load({ commit, state }) {
    if (state.messages && state.messages.length) {
      return;
    }
    return axios
      .get(zRoute('ajax.chat2.invitation_message.index', {
        random: true,
        limit: 30,
      }))
      .then((response) => {
        commit('setMessages', response.data.data);
      });
  },
  randomMessages({ commit, state }, name) {
    return new Promise((resolve, reject) => {

      const allMessages = state.messages;
      /**
       * Get random messages
       */
      let messagesTemplates = [];
      if (allMessages.length > 3) {
        let temp = allMessages.slice(0);
        for (let i = 0; i < 3; i++) {
          let rand = Math.floor(Math.random() * temp.length);
          messagesTemplates.push('Hi :name:! ' + temp[rand].message);
          temp.splice(rand, 1);
        }
      } else {
        messagesTemplates = allMessages;
      }

      /**
       * Type template to message
       */
      let messages = [];
      messagesTemplates.forEach((message) => {
        messages.push(message.replaceAll(':name:', name));
      });
      resolve(messages);
    });
  },
};

// mutations
const mutations = {
  setMessages: (state, profiles) => {
    state.messages = profiles;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
